import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import HomeLoan from './pages/HomeLoan';
import Calculator from './pages/Calculator';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/home-loan" element={<HomeLoan />} />
      <Route path="/calculator" element={<Calculator />} />
    </Routes>
  );
}

export default AppRoutes; 